import { API_URL } from "./config";
import { useEffect, useState } from "react";
import token from './Token'
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import './Scheduler.css';
import moment from 'moment';
import _ from 'lodash';
import ReusableModal from "./ReusableModal";

function Scheduler() {
    const [schedules, setSchedules] = useState([]);
    const [templates, setTemplates] = useState(null);
    const [templateSNames, setTemplateSNames] = useState([]);
    const [selectedTemplateId, setSelectedTemplateId] = useState('');
    const [showCreateProgrammeModal, setShowCreateProgrammeModal] = useState(false);
    const [templateToCreateFrom, setTemplateToCreateFrom] = useState('');
    const [isSavingProgramme, setIsSavingProgramme] = useState(false);
    const [isDeletingProgramme, setIsDeletingProgramme] = useState(false);
    const [bankTargetSubScheduleId, setBankTargetSubScheduleId] = useState('');
    const [bankAttempts, setBankAttempts] = useState(1);
    const [isBankingAttempts, setIsBankingAttempts] = useState(false);

    const [programme, setProgramme] = useState(null);

    const fetchSchedules = async () => {
        const [response, responseTemplate] = await Promise.all([
            fetch(API_URL + '/schedules?token=' + token),
            fetch(API_URL + '/templates?token=' + token)
        ]);
        const data = await response.json();
        console.log(data);
        setSchedules(data);

        const dataTemplate = await responseTemplate.json();
        console.log(dataTemplate);
        setTemplates(dataTemplate);

        return {
            schedules: data,
            templates: dataTemplate
        };
    }

    useEffect(() => {
        fetchSchedules();
    }, []);

    const handleTemplateChange = (event) => {
        setSelectedTemplateId(event.target.value);
    }

    const getTemplateStampId = (template) => {
        if (!template) {
            return '';
        }
        if (template.id) {
            return template.id;
        }
        if (template.stampId) {
            return template.stampId;
        }
        if (template.practicalId) {
            return template.practicalId.toUpperCase();
        }
        return '';
    }

    const getTemplateProgrammeName = (template) => {
        if (!template) {
            return '';
        }
        return template.practicalId || template.templateName || (getTemplateStampId(template) || '').toLowerCase();
    }

    const getTemplateDisplayName = (template) => {
        if (!template) {
            return '';
        }
        const stampId = getTemplateStampId(template);
        const label = template.description || template.tname || template.practicalId || template.templateName || stampId;
        return stampId && label !== stampId ? `${label} (${stampId})` : label;
    }

    const getTemplateForStampId = (stampId, templatesToSearch = templates) => {
        if (!templatesToSearch) {
            return null;
        }
        return templatesToSearch.find(template => getTemplateStampId(template) === stampId) || null;
    }

    const getTemplateSubtaskNames = (stampId, templatesToSearch = templates) => {
        const template = getTemplateForStampId(stampId, templatesToSearch);
        if (!template || !Array.isArray(template.subs)) {
            return [];
        }
        return template.subs.map(sub => sub.sname).filter(Boolean);
    }

    const hydrateProgrammeForEditing = (programmeToHydrate) => {
        if (!programmeToHydrate) {
            return null;
        }

        const hydratedProgramme = _.cloneDeep(programmeToHydrate);
        hydratedProgramme.subs = Array.isArray(hydratedProgramme.subs) ? hydratedProgramme.subs : [];
        hydratedProgramme.subs.forEach(sub => {
            sub.dayOfWeek = Array.isArray(sub.dayOfWeek) ? sub.dayOfWeek : [];
            sub.dayOfMonth = Array.isArray(sub.dayOfMonth) ? sub.dayOfMonth : [];
            sub.dayOfWeekText = sub.dayOfWeek.join(', ');
            sub.dayOfMonthText = sub.dayOfMonth.join(', ');
        });
        return hydratedProgramme;
    }

    useEffect(() => {
        if (!selectedTemplateId) {
            setProgramme(null);
            setTemplateSNames([]);
            setBankTargetSubScheduleId('');
            return;
        }

        const selectedProgramme = schedules.find(schedule => schedule.stampId === selectedTemplateId);
        if (!selectedProgramme) {
            setProgramme(null);
            setTemplateSNames([]);
            return;
        }

        setProgramme(hydrateProgrammeForEditing(selectedProgramme));
        const selectedTemplate = (templates || []).find(template => {
            const templateStampId = template.id || template.stampId || (template.practicalId ? template.practicalId.toUpperCase() : '');
            return templateStampId === selectedTemplateId;
        });
        setTemplateSNames(selectedTemplate && Array.isArray(selectedTemplate.subs) ? selectedTemplate.subs.map(sub => sub.sname).filter(Boolean) : []);
    }, [selectedTemplateId, schedules, templates]);

    const getSubScheduleOptionValue = (sub, index) => {
        return sub.subScheduleId || `${sub.sname || 'scheduled-subtask'}-${index}`;
    }

    const getSelectedBankSubtask = () => {
        if (!programme || !Array.isArray(programme.subs)) {
            return null;
        }
        return programme.subs.find((sub, index) => getSubScheduleOptionValue(sub, index) === bankTargetSubScheduleId) || null;
    }

    useEffect(() => {
        const programmeSubs = programme && Array.isArray(programme.subs) ? programme.subs : [];
        if (programmeSubs.length === 0) {
            setBankTargetSubScheduleId('');
            return;
        }

        const selectedStillExists = programmeSubs.some((sub, index) => getSubScheduleOptionValue(sub, index) === bankTargetSubScheduleId);
        if (!selectedStillExists) {
            setBankTargetSubScheduleId(getSubScheduleOptionValue(programmeSubs[0], 0));
        }
    }, [programme, bankTargetSubScheduleId]);

    const handleTextChange = (index, value, type) => {
        const newProgramme = _.cloneDeep(programme);
        if (type === 'sname') {
            newProgramme.subs[index].sname = value;
        } else if (type === 'frequencyType') {
            newProgramme.subs[index].frequencyType = value;
        } else if (type === 'dayOfWeek') {
            newProgramme.subs[index].dayOfWeekText = value;
            newProgramme.subs[index].dayOfWeek = value.split(',').map(day => parseInt(day));
        } else if (type === 'dayOfMonth') {
            newProgramme.subs[index].dayOfMonthText = value;
            newProgramme.subs[index].dayOfMonth = value.split(',').map(day => parseInt(day));
        } else if (type === 'lastEvaluationDate') {
            newProgramme.subs[index].lastEvaluationDate = value;
        } else if (type === 'forceEvaluation') {
            newProgramme.subs[index].forceEvaluation = value;
        }
        setProgramme(newProgramme);
    }

    const get2AMOfDate = (date) => { // timezone incorporated
        return moment(date).add(-2, "hours").startOf('day').add(2, 'hours') // closest 2AM in the past of lastEvaluationDate
    }

    const getNFromFrequencyTypeForWeek = (frequencyType) => {
        // extract N from "everyNWeeks" of frequencyType
        const regex = /every(\d+)Weeks/;
        const match = regex.exec(frequencyType);

        // Check if there's a match
        if (match) {
            // Return the captured digit
            return Number(match[1]);
        } else {
            // Return undefined if no match
            return undefined;
        }
    }

    const getNFromFrequencyTypeForMonth = (frequencyType) => {
        // extract N from "everyNMonths" of frequencyType
        const regex = /every(\d+)Months/;
        const match = regex.exec(frequencyType);

        // Check if there's a match
        if (match) {
            // Return the captured digit
            return Number(match[1]);
        } else {
            // Return undefined if no match
            return undefined;
        }
    }

    const getNextEvaluationDate = (frequencyType, dayOfWeek, dayOfMonth, lastEvaluationDate, forceEvaluation = false) => {
        /* Frequency type: daily, weekly, monthly
        dayOfWeek: [] // 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday - for weekly type
        dayOfMonth: [] // 1-31 - for monthly type
        lastEvaluationDate: an ISOString
        */
        //    console.log('Timezone: ', timezone)
        try {
            if (forceEvaluation) { // force evaluation => just return the lastEvaluationDate
                return lastEvaluationDate
            }
            const lastEvaluationDateMoment = moment(lastEvaluationDate) // take lastEvaluationDate, convert to Europe/Paris timezone
            //    console.log('lastEvaluationDateMoment: ', lastEvaluationDateMoment.toISOString())
            const twoAMOfLastEvaluationDate = get2AMOfDate(lastEvaluationDateMoment) // closest 2AM in the past of lastEvaluationDate
            //    console.log('@2AM: ', twoAMOfLastEvaluationDate.toISOString())
            //    console.log('lastEvaluationDateMoment: ', lastEvaluationDateMoment.toISOString())
            if (frequencyType === "daily") {
                return twoAMOfLastEvaluationDate.add(1, 'days').toISOString()
            }
            if (frequencyType === "weekly") {
                const dayOfWeekOfTwoAMOfLastEvaluationDate = twoAMOfLastEvaluationDate.day()
                let dayOfWeekPlusOneWeek = dayOfWeek.map(day => day + 7)
                let dayOfWeekExtended = dayOfWeek.concat(dayOfWeekPlusOneWeek)
                dayOfWeekExtended = dayOfWeekExtended.sort((a, b) => a - b) // sort the array in ascending order
                // There are two possibilities: (1) the deltaDays (see below) is zero, (2) the deltaDays is greater than zero
                let nextDayOfWeek = dayOfWeek.find(day => day >= dayOfWeekOfTwoAMOfLastEvaluationDate)
                let deltaDays = nextDayOfWeek - dayOfWeekOfTwoAMOfLastEvaluationDate // >=0 
                let nextEvaluationDate = moment(twoAMOfLastEvaluationDate).add(deltaDays, 'days')
                // Here, if the deltaDays is zero, we need to find the next dayOfWeek that is greater than the dayOfWeekOfTwoAMOfLastEvaluationDate
                // console.log('nextEvaluationDate: ', nextEvaluationDate.toISOString())
                // console.log('lastEvaluationDateMoment: ', lastEvaluationDateMoment.toISOString())
                // console.log('nextEvaluationDate.isBefore(lastEvaluationDateMoment): ', !nextEvaluationDate.isBefore(lastEvaluationDateMoment))
                if (!nextEvaluationDate.isAfter(lastEvaluationDateMoment)) {
                    nextDayOfWeek = dayOfWeekExtended.find(day => day > dayOfWeekOfTwoAMOfLastEvaluationDate) // > not >=
                    deltaDays = nextDayOfWeek - dayOfWeekOfTwoAMOfLastEvaluationDate // >0 
                    nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                }
                return nextEvaluationDate.toISOString()
            }

            const weekFrequencyInterval = getNFromFrequencyTypeForWeek(frequencyType);
            if (weekFrequencyInterval) {
                // extract N from "everyNWeeks" of frequencyType
                // Example: if every2Weeks and dayOfWeek=[1, 3, 5] (Monday, Wednesday, Friday)
                // if the lastEvaluationDate is on a Monday, the next evaluation date is Wednesday
                // if the lastEvaluationDate is on a Wednesday, the next evaluation date is Friday
                // if the lastEvaluationDate is on a Friday, the next evaluation date is Monday of the next 2 weeks
                const N = weekFrequencyInterval
                let dayOfWeekOfTwoAMOfLastEvaluationDate = twoAMOfLastEvaluationDate.day()

                // Change Sunday to 7 instead of 0
                if (dayOfWeekOfTwoAMOfLastEvaluationDate === 0) {
                    dayOfWeekOfTwoAMOfLastEvaluationDate = 7
                }
                if (dayOfWeek.includes(0)) {
                    dayOfWeek = dayOfWeek.map(day => day === 0 ? 7 : day)
                }

                // Sort dayOfWeek in ascending order
                dayOfWeek = dayOfWeek.sort((a, b) => a - b)

                // console.log('dayOfWeekOfTwoAMOfLastEvaluationDate: ', dayOfWeekOfTwoAMOfLastEvaluationDate)
                // console.log('dayOfWeek: ', dayOfWeek)

                let nextEvaluationDate
                if (dayOfWeekOfTwoAMOfLastEvaluationDate < Math.max(...dayOfWeek)) {
                    // console.log('dayOfWeekOfTwoAMOfLastEvaluationDate < Math.max(...dayOfWeek)')
                    // This is Monday or Wednesday case in the example above
                    // The logic is similar to the weekly case
                    let nextDayOfWeek = dayOfWeek.find(day => day >= dayOfWeekOfTwoAMOfLastEvaluationDate)
                    // console.log('nextDayOfWeek: ', nextDayOfWeek)
                    let deltaDays = nextDayOfWeek - dayOfWeekOfTwoAMOfLastEvaluationDate
                    nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                    if (!nextEvaluationDate.isAfter(lastEvaluationDateMoment)) {
                        nextDayOfWeek = dayOfWeek.find(day => day > dayOfWeekOfTwoAMOfLastEvaluationDate)
                        deltaDays = nextDayOfWeek - dayOfWeekOfTwoAMOfLastEvaluationDate
                        nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                    }
                } else { // dayOfWeekOfTwoAMOfLastEvaluationDate >= Math.max(...dayOfWeek)
                    // console.log('dayOfWeekOfTwoAMOfLastEvaluationDate >= Math.max(...dayOfWeek)')
                    // This is Friday case in the example above
                    let firstDayOfWeek = Math.min(...dayOfWeek)
                    let deltaDays = - (dayOfWeekOfTwoAMOfLastEvaluationDate - firstDayOfWeek) + 7 * N
                    nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                    // No need to check if nextEvaluationDate is before lastEvaluationDate
                }
                return nextEvaluationDate.toISOString()
            }

            if (frequencyType === "monthly") {
                const dayOfMonthOfTwoAMOfLastEvaluationDate = twoAMOfLastEvaluationDate.date() // 1-31
                let daysInMonth = moment(lastEvaluationDate).daysInMonth()
                let dayOfMonthPlusOneMonth = dayOfMonth.map(day => day + daysInMonth)
                let dayOfMonthExtended = dayOfMonth.concat(dayOfMonthPlusOneMonth)
                dayOfMonthExtended = dayOfMonthExtended.sort((a, b) => a - b) // sort the array in ascending order
                // There are two possibilities: (1) the deltaDays (see below) is zero, (2) the deltaDays is greater than zero
                let nextDayOfMonth = dayOfMonth.find(day => day >= dayOfMonthOfTwoAMOfLastEvaluationDate)
                let deltaDays = nextDayOfMonth - dayOfMonthOfTwoAMOfLastEvaluationDate // >=0 
                let nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                // Here, if the deltaDays is zero, we need to find the next dayOfMonth that is greater than the dayOfMonthOfTwoAMOfLastEvaluationDate
                if (!nextEvaluationDate.isAfter(lastEvaluationDateMoment)) {
                    nextDayOfMonth = dayOfMonthExtended.find(day => day > dayOfMonthOfTwoAMOfLastEvaluationDate) // > not >=
                    deltaDays = nextDayOfMonth - dayOfMonthOfTwoAMOfLastEvaluationDate // >0 
                    nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                }
                return nextEvaluationDate.toISOString()
            }

            const monthFrequencyInterval = getNFromFrequencyTypeForMonth(frequencyType);
            if (monthFrequencyInterval) {
                // extract N from "everyNMonths" of frequencyType
                // Example: if every2Months and dayOfMonth=[1, 15] (1st and 15th of the month)
                // if the lastEvaluationDate is on the 1st, the next evaluation date is the 15th
                // if the lastEvaluationDate is on the 15th, the next evaluation date is the 1st of the next 2 months
                const N = monthFrequencyInterval // e.g., 2
                let dayOfMonthOfTwoAMOfLastEvaluationDate = twoAMOfLastEvaluationDate.date() // e.g., 1

                // maxDayOfMonth is the maximum of dayOfMonth or the number of days in the month
                let maxDayOfMonth = Math.max(...dayOfMonth)
                if (maxDayOfMonth > moment(lastEvaluationDate).daysInMonth()) {
                    maxDayOfMonth = moment(lastEvaluationDate).daysInMonth()
                }

                // if dayOfMonthOfTwoAMOfLastEvaluationDate equals maximum of dayOfMonth, schedule for the next 2 months
                if (dayOfMonthOfTwoAMOfLastEvaluationDate >= maxDayOfMonth) {
                    // console.log('>=')
                    let dayOfTwoAMOfNextEvaluationDate = Math.min(...dayOfMonth)
                    // console.log('day of month: ', dayOfMonth)
                    let nextEvaluationDate = twoAMOfLastEvaluationDate.set('date', dayOfTwoAMOfNextEvaluationDate).set('month', twoAMOfLastEvaluationDate.month() + N)
                    // console.log('date set to: ', dayOfTwoAMOfNextEvaluationDate)
                    // console.log(twoAMOfLastEvaluationDate.month())
                    // console.log('month set to: ', twoAMOfLastEvaluationDate.month() + N)
                    // console.log('nextEvaluationDate: ', nextEvaluationDate.toISOString())
                    return nextEvaluationDate.toISOString()
                } else {
                    // console.log('<')
                    // if dayOfMonthOfTwoAMOfLastEvaluationDate is less than maximum of dayOfMonth, schedule for the current month
                    let nextEvaluationDate
                    let daysInMonth = moment(lastEvaluationDate).daysInMonth() // e.g., 30
                    let dayOfMonthPlusOneMonth = dayOfMonth.map(day => day + daysInMonth) // e.g., [31, 45]
                    let dayOfMonthExtended = dayOfMonth.concat(dayOfMonthPlusOneMonth) // e.g., [1, 15, 31, 45]
                    dayOfMonthExtended = dayOfMonthExtended.sort((a, b) => a - b) // sort the array in ascending order
                    let nextDayOfMonth = dayOfMonth.find(day => day >= dayOfMonthOfTwoAMOfLastEvaluationDate) // e.g., 15
                    let deltaDays = nextDayOfMonth - dayOfMonthOfTwoAMOfLastEvaluationDate // >=0 
                    nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                    // Here, if the deltaDays is zero, we need to find the next dayOfMonth that is greater than the dayOfMonthOfTwoAMOfLastEvaluationDate
                    if (!nextEvaluationDate.isAfter(lastEvaluationDateMoment)) {
                        nextDayOfMonth = dayOfMonthExtended.find(day => day > dayOfMonthOfTwoAMOfLastEvaluationDate) // > not >=
                        deltaDays = nextDayOfMonth - dayOfMonthOfTwoAMOfLastEvaluationDate // >0 
                        nextEvaluationDate = twoAMOfLastEvaluationDate.add(deltaDays, 'days')
                    }
                    // console.log('nextEvaluationDate: ', nextEvaluationDate.toISOString())
                    return nextEvaluationDate.toISOString()
                }
            }
        } catch (error) {
            console.log('Error: ', error)
            return 'Error'
        }
    }

    const addSubtask = () => {
        const newProgramme = _.cloneDeep(programme);
        newProgramme.subs.push({
            sname: '',
            frequencyType: 'daily',
            dayOfWeek: [],
            dayOfMonth: [],
            lastEvaluationDate: moment().toISOString(),
            dayOfWeekText: '',
            dayOfMonthText: '',
        });
        setProgramme(newProgramme);
    }

    const deleteSubtask = (index) => {
        const newProgramme = _.cloneDeep(programme);
        const subtaskToDelete = newProgramme.subs[index];
        if (Number(subtaskToDelete?.bankedAttempts || 0) > 0) {
            const shouldDelete = window.confirm('Delete scheduled subtask "' + subtaskToDelete.sname + '" and discard ' + subtaskToDelete.bankedAttempts + ' banked attempts?');
            if (!shouldDelete) {
                return;
            }
        }
        newProgramme.subs.splice(index, 1);
        setProgramme(newProgramme);
    }

    const getProgrammeForSave = (programmeToSave) => {
        let mProgramme = _.cloneDeep(programmeToSave);
        if (mProgramme.hasOwnProperty("_id")) {
            delete mProgramme._id;
        }
        mProgramme.subs = Array.isArray(mProgramme.subs) ? mProgramme.subs : [];
        mProgramme.subs.forEach(sub => {
            delete sub.dayOfWeekText;
            delete sub.dayOfMonthText;
            if (sub.hasOwnProperty("forceEvaluation")) {
                if (!sub.forceEvaluation) {
                    delete sub.forceEvaluation;
                }
            }
        });
        return mProgramme;
    }

    const saveProgramme = async (programmeToSave) => {
        let formData = new URLSearchParams();
        formData.append("data", JSON.stringify(getProgrammeForSave(programmeToSave)));

        let result = await fetch(API_URL + '/editschedule?token=' + token, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString()
        });

        return await result.json();
    }

    const save = async () => {
        let data = await saveProgramme(programme);
        alert(JSON.stringify(data));
    }

    const bankAttemptsForSelectedSubtask = async () => {
        const selectedSubtask = getSelectedBankSubtask();
        const attempts = Number(bankAttempts);
        if (!programme || !selectedSubtask) {
            alert('Please choose a scheduled subtask to bank');
            return;
        }
        if (!Number.isInteger(attempts) || attempts <= 0) {
            alert('Bank attempts must be a positive integer');
            return;
        }

        const formData = new URLSearchParams();
        formData.append("data", JSON.stringify({
            stampId: programme.stampId,
            scheduleSubId: selectedSubtask.subScheduleId,
            sname: selectedSubtask.subScheduleId ? undefined : selectedSubtask.sname,
            attempts: attempts
        }));

        setIsBankingAttempts(true);
        try {
            const result = await fetch(API_URL + '/bankScheduledSubtask?token=' + token, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            });
            if (!result.ok) {
                throw new Error('Server returned ' + result.status);
            }
            const data = await result.json();
            if (data.error) {
                throw new Error(data.error);
            }

            const refreshed = await fetchSchedules();
            const refreshedProgramme = refreshed.schedules.find(schedule => schedule.stampId === selectedTemplateId);
            if (refreshedProgramme) {
                setProgramme(hydrateProgrammeForEditing(refreshedProgramme));
                setTemplateSNames(getTemplateSubtaskNames(refreshedProgramme.stampId, refreshed.templates));
            }
            setBankAttempts(1);
            alert('Banked attempts: ' + data.bankedAttempts);
        } catch (error) {
            alert('Failed to bank attempts: ' + error.message);
        } finally {
            setIsBankingAttempts(false);
        }
    }

    const buildEmptyProgrammeFromTemplate = (template) => {
        const emptyProgramme = {
            templateName: getTemplateProgrammeName(template),
            stampId: getTemplateStampId(template),
            subs: []
        };
        if (template.username) {
            emptyProgramme.username = template.username;
        }
        return emptyProgramme;
    }

    const programmeExistsForTemplate = (template) => {
        const stampId = getTemplateStampId(template);
        return schedules.some(schedule => schedule.stampId === stampId);
    }

    const openCreateProgrammeModal = () => {
        const firstAvailableTemplate = (templates || []).find(template => getTemplateStampId(template) && !programmeExistsForTemplate(template));
        setTemplateToCreateFrom(firstAvailableTemplate ? getTemplateStampId(firstAvailableTemplate) : '');
        setShowCreateProgrammeModal(true);
    }

    const closeCreateProgrammeModal = () => {
        if (isSavingProgramme) {
            return;
        }
        setShowCreateProgrammeModal(false);
    }

    const createProgramme = async () => {
        const selectedTemplate = getTemplateForStampId(templateToCreateFrom);
        if (!selectedTemplate) {
            alert('Please choose a subtask template');
            return;
        }
        if (programmeExistsForTemplate(selectedTemplate)) {
            alert('This template already has a schedule programme');
            return;
        }

        const emptyProgramme = buildEmptyProgrammeFromTemplate(selectedTemplate);
        setIsSavingProgramme(true);
        try {
            const data = await saveProgramme(emptyProgramme);
            alert(JSON.stringify(data));
            setShowCreateProgrammeModal(false);
            setSchedules(previousSchedules => [...previousSchedules, emptyProgramme]);
            setSelectedTemplateId(emptyProgramme.stampId);
            setProgramme(hydrateProgrammeForEditing(emptyProgramme));
            setTemplateSNames(getTemplateSubtaskNames(emptyProgramme.stampId));
            await fetchSchedules();
        } catch (error) {
            alert('Failed to create schedule programme: ' + error.message);
        } finally {
            setIsSavingProgramme(false);
        }
    }

    const deleteProgramme = async () => {
        if (!programme) {
            return;
        }
        if (!window.confirm('Delete schedule programme "' + programme.stampId + '"?')) {
            return;
        }

        setIsDeletingProgramme(true);
        try {
            const response = await fetch(API_URL + '/deleteschedule?token=' + token + '&stampId=' + encodeURIComponent(programme.stampId));
            if (!response.ok) {
                throw new Error('Server returned ' + response.status);
            }
            const data = await response.json();
            alert(JSON.stringify(data));
            setSchedules(previousSchedules => previousSchedules.filter(schedule => schedule.stampId !== programme.stampId));
            setSelectedTemplateId('');
            setProgramme(null);
            setTemplateSNames([]);
            await fetchSchedules();
        } catch (error) {
            alert('Failed to delete schedule programme: ' + error.message);
        } finally {
            setIsDeletingProgramme(false);
        }
    }

    const templateOptions = templates || [];
    const selectedCreateTemplate = getTemplateForStampId(templateToCreateFrom);
    const bankableSubtasks = programme && Array.isArray(programme.subs) ? programme.subs : [];
    const selectedBankSubtask = getSelectedBankSubtask();
    const selectedBankNextEvaluation = selectedBankSubtask ? getNextEvaluationDate(
        selectedBankSubtask.frequencyType,
        selectedBankSubtask.dayOfWeek,
        selectedBankSubtask.dayOfMonth,
        selectedBankSubtask.lastEvaluationDate,
        selectedBankSubtask.forceEvaluation
    ) : null;
    const selectedBankNextEvaluationText = selectedBankNextEvaluation && selectedBankNextEvaluation !== 'Error'
        ? moment(selectedBankNextEvaluation).format('dddd, MMMM Do YYYY, HH:mm')
        : 'n/a';
    const parsedBankAttempts = Number(bankAttempts);
    const canBankAttempts = !!programme && !!selectedBankSubtask && Number.isInteger(parsedBankAttempts) && parsedBankAttempts > 0 && !isBankingAttempts;


    return (
        <div className="AppRootDesktop">
            <div className="AppRootInnerOverlay">
                <div className="scheduler-page edit-page">
                    <div className="action-bar">
                        <div className="action-bar-heading">
                            <h1>Schedule Programmes</h1>
                            <div className="action-bar-subtitle">Pick a schedule to view and edit its subtasks.</div>
                        </div>
                        <div className="action-bar-controls">
                            <Form.Select
                                aria-label="Select a schedule programme"
                                value={selectedTemplateId}
                                onChange={handleTemplateChange}
                            >
                                <option value="">Select a schedule programme</option>
                                {schedules.map((schedule, index) => (
                                    <option key={index} value={schedule.stampId}>{schedule.stampId}</option>
                                ))}
                            </Form.Select>
                            <Button
                                className="create-programme-button"
                                variant="success"
                                onClick={openCreateProgrammeModal}
                                disabled={!templates}
                                aria-label="Create schedule programme"
                            >
                                +
                            </Button>
                        </div>
                    </div>

                    <Container fluid="lg" className="scheduler-container">
                        <Row className="g-4">
                            <Col xs={12}>
                                <div className="task-card schedule-guide">
                                    <h2 className="section-title">Editor Guide</h2>
                                    <p className="guide-line">
                                        Available subtask names:
                                        <span className="guide-highlight"> {templateSNames.length ? templateSNames.join(', ') : 'n/a'}</span>
                                    </p>
                                    <p className="guide-line">
                                        Available frequency types:
                                        <span className="guide-highlight"> daily, weekly, everyNWeeks, monthly, everyNMonths</span>
                                    </p>
                                    <p className="guide-hint">Assign an eligible subtask, fine-tune its recurrence, then save to publish the programme.</p>
                                </div>
                            </Col>
                        </Row>

                        {programme ? (
                            <>
                                <Row className="g-4">
                                    <Col xs={12}>
                                        <div className="task-card bank-attempts-panel">
                                            <div className="bank-attempts-heading">
                                                <div>
                                                    <h2 className="section-title">Bank Attempts</h2>
                                                    <div className="bank-attempts-subtitle">Add credits for future automatic reschedules.</div>
                                                </div>
                                                {selectedBankSubtask && (
                                                    <div className="bank-attempts-count">
                                                        {Number(selectedBankSubtask.bankedAttempts || 0)} banked
                                                    </div>
                                                )}
                                            </div>
                                            <div className="bank-attempts-controls">
                                                <div className="bank-attempts-control-cell">
                                                    <Form.Group className="bank-attempts-field" controlId="bank-scheduled-subtask">
                                                        <Form.Label>Scheduled subtask</Form.Label>
                                                        <Form.Select
                                                            value={bankTargetSubScheduleId}
                                                            onChange={(event) => setBankTargetSubScheduleId(event.target.value)}
                                                            disabled={isBankingAttempts}
                                                        >
                                                            {bankableSubtasks.map((sub, index) => (
                                                                <option key={getSubScheduleOptionValue(sub, index)} value={getSubScheduleOptionValue(sub, index)}>
                                                                    {sub.sname} ({Number(sub.bankedAttempts || 0)} banked)
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                                <div className="bank-attempts-control-cell">
                                                    <Form.Group className="bank-attempts-field" controlId="bank-attempt-count">
                                                        <Form.Label>Attempts</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            value={bankAttempts}
                                                            onChange={(event) => setBankAttempts(event.target.value)}
                                                            disabled={isBankingAttempts}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="bank-attempts-control-cell bank-attempts-action-cell">
                                                    <Button
                                                        className="bank-attempts-button"
                                                        variant="success"
                                                        onClick={bankAttemptsForSelectedSubtask}
                                                        disabled={!canBankAttempts}
                                                    >
                                                        {isBankingAttempts ? 'Banking...' : 'Bank'}
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="bank-attempts-next">
                                                Next evaluation: <span>{selectedBankNextEvaluationText}</span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="g-4">
                                    {programme.subs.map((sub, index) => {
                                        const isValidSname = templateSNames.includes(sub.sname);
                                        const nextEvalRaw = getNextEvaluationDate(
                                            sub.frequencyType,
                                            sub.dayOfWeek,
                                            sub.dayOfMonth,
                                            sub.lastEvaluationDate,
                                            sub.forceEvaluation
                                        );
                                        const nextEvalText = nextEvalRaw && nextEvalRaw !== 'Error'
                                            ? moment(nextEvalRaw).format('dddd, MMMM Do YYYY, HH:mm')
                                            : 'n/a';

                                        return (
                                            <Col xs={12} lg={6} key={index}>
                                                <div className="task-card schedule-item">
                                                    <div className="schedule-item-number">Task {index + 1}</div>

                                                    <Form.Group className="mb-3" controlId={`scheduler-sname-${index}`}>
                                                        <Form.Label>Subtask Name</Form.Label>
                                                        <Form.Select
                                                            value={sub.sname || ''}
                                                            onChange={(event) => handleTextChange(index, event.target.value, 'sname')}
                                                        >
                                                            <option value="">Select a subtask</option>
                                                            {templateSNames.map((name) => (
                                                                <option key={name} value={name}>{name}</option>
                                                            ))}
                                                            {!isValidSname && sub.sname && (
                                                                <option value={sub.sname}>{sub.sname} (custom)</option>
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                    {!isValidSname && sub.sname && (
                                                        <div className="schedule-item-warning">Subtask name is not part of the template</div>
                                                    )}

                                                    <Form.Group className="mb-3" controlId={`scheduler-frequency-${index}`}>
                                                        <Form.Label>Frequency Type</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={sub.frequencyType || ''}
                                                            onChange={(event) => handleTextChange(index, event.target.value, 'frequencyType')}
                                                        />
                                                    </Form.Group>

                                                    <Row className="g-3 mb-3">
                                                        <Col xs={12} md={6}>
                                                            <Form.Group controlId={`scheduler-dow-${index}`}>
                                                                <Form.Label>Days of Week</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="e.g. 1,3,5"
                                                                    value={sub.dayOfWeekText || ''}
                                                                    onChange={(event) => handleTextChange(index, event.target.value, 'dayOfWeek')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs={12} md={6}>
                                                            <Form.Group controlId={`scheduler-dom-${index}`}>
                                                                <Form.Label>Days of Month</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="e.g. 1,15,30"
                                                                    value={sub.dayOfMonthText || ''}
                                                                    onChange={(event) => handleTextChange(index, event.target.value, 'dayOfMonth')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Form.Group className="mb-3" controlId={`scheduler-last-eval-${index}`}>
                                                        <Form.Label>Last Evaluation (ISO)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={sub.lastEvaluationDate || ''}
                                                            onChange={(event) => handleTextChange(index, event.target.value, 'lastEvaluationDate')}
                                                        />
                                                    </Form.Group>

                                                    <div className="schedule-item-summary">
                                                        <div className="summary-label">Next evaluation</div>
                                                        <div className="summary-value">{nextEvalText}</div>
                                                    </div>
                                                    <div className="schedule-item-summary bank-summary">
                                                        <div className="summary-label">Banked attempts</div>
                                                        <div className="summary-value">{Number(sub.bankedAttempts || 0)}</div>
                                                    </div>

                                                    <Form.Group className="force-eval-toggle" controlId={`scheduler-force-${index}`}>
                                                        <Form.Check
                                                            type="switch"
                                                            label="Force evaluation on LED"
                                                            onChange={(event) => handleTextChange(index, event.target.checked, 'forceEvaluation')}
                                                            checked={!!sub.forceEvaluation}
                                                        />
                                                    </Form.Group>

                                                    <div className="schedule-item-actions">
                                                        <Button variant="danger" onClick={() => deleteSubtask(index)}>Delete</Button>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </>
                        ) : (
                            <Row className="g-4">
                                <Col xs={12}>
                                    <div className="task-card schedule-empty">Select a schedule programme above to start editing.</div>
                                </Col>
                            </Row>
                        )}

                        <div className="button-group scheduler-actions">
                            <Button variant="success" onClick={addSubtask} disabled={!programme}>Add subtask</Button>
                            <Button variant="primary" onClick={save} disabled={!programme}>Save</Button>
                            <Button variant="danger" onClick={deleteProgramme} disabled={!programme || isDeletingProgramme}>
                                {isDeletingProgramme ? 'Deleting...' : 'Delete programme'}
                            </Button>
                        </div>
                    </Container>

                    <ReusableModal
                        show={showCreateProgrammeModal}
                        onHide={closeCreateProgrammeModal}
                        title="Create Schedule Programme"
                        footer={(
                            <>
                                <Button variant="secondary" onClick={closeCreateProgrammeModal} disabled={isSavingProgramme}>Cancel</Button>
                                <Button variant="success" onClick={createProgramme} disabled={!templateToCreateFrom || isSavingProgramme}>
                                    {isSavingProgramme ? 'Creating...' : 'Create'}
                                </Button>
                            </>
                        )}
                    >
                        <Form.Group controlId="create-schedule-programme-template">
                            <Form.Label>Subtask Template</Form.Label>
                            <Form.Select
                                value={templateToCreateFrom}
                                onChange={(event) => setTemplateToCreateFrom(event.target.value)}
                                disabled={isSavingProgramme}
                            >
                                <option value="">Select a subtask template</option>
                                {templateOptions.map((template, index) => {
                                    const stampId = getTemplateStampId(template);
                                    const hasProgramme = programmeExistsForTemplate(template);
                                    return (
                                        <option key={`${stampId}-${index}`} value={stampId} disabled={!stampId || hasProgramme}>
                                            {getTemplateDisplayName(template)}{hasProgramme ? ' - already has programme' : ''}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </Form.Group>
                        <div className="create-programme-summary">
                            {selectedCreateTemplate ? (
                                <>
                                    Creates an empty programme for <strong>{getTemplateStampId(selectedCreateTemplate)}</strong> with <strong>0 subtasks</strong>.
                                </>
                            ) : (
                                'Choose a template to create a schedule programme with no subtasks.'
                            )}
                        </div>
                    </ReusableModal>
                </div>
            </div>
        </div>
    )
}

export default Scheduler;
